import { useAuthContext } from 'context/AuthContext'
import CIMSSelect from 'components/CIMSSelect'
import { useOptions } from 'components/CIMSSelect/hooks/useOptions'
import { CIMSModule, CIMSPage, pathify } from '@cims-online/shared'
import { useHistory } from 'react-router-dom'
import { useRouteMatches } from 'hooks/useRouteMatches'
import { useGetProjectSelectorProjectsQuery } from 'schema'
import { DefaultQueryHookOptions } from 'utils/defaults'

const ProjectSelector: React.VFC<{ projectId?: string }> = ({ projectId }) => {
  const { user } = useAuthContext()
  const { push } = useHistory()
  const { replaceHistory, param } = useRouteMatches()
  const { data } = useGetProjectSelectorProjectsQuery({
    ...DefaultQueryHookOptions,
    variables: {
      input: {
        active: true,
        deleted: false,
        projectName: {
          null: false,
        },
      },
    },
  })
  const navKey =
    CIMSPage.fromPath({
      module: param('module'),
      page: param('page'),
    })?.id ?? param('home')
  const options = useOptions({
    items: data?.projects?.records,
    value: 'globalId',
    label: 'projectName',
    sort: 'projectName',
  })
  const workflowId = param('workflowId')
  return (
    <CIMSSelect
      style={{ minWidth: 250 }}
      simple
      options={options}
      value={projectId}
      disabled={!user}
      placeholder="Select a Project"
      onChange={(value) => {
        const projectId = value as string
        if (!projectId) return push(pathify(CIMSModule.Home.pathname))
        else if (navKey === 'home' || navKey === 'developer' || !!workflowId)
          return push(pathify(projectId, CIMSModule.Home.pathname))
        return replaceHistory({
          key: 'projectId',
          action: 'replace',
          value: projectId,
        })
      }}
    />
  )
}

export default ProjectSelector
